export default __webpack_public_path__ + "static/media/twitter-card.5eb4cf34.JPG";